import type { Option } from '../components/Form/SearchableSelect';

export const industries = (): Option[] => [
    { value: 'accounting', label: __('Accounting & Financial') },
    { value: 'agriculture', label: __('Agriculture') },
    { value: 'animals', label: __('Animal & Pet') },
    { value: 'architectural', label: __('Architectural') },
    { value: 'art', label: __('Art & Design') },
    { value: 'attorney', label: __('Attorney & Law') },
    { value: 'automotive', label: __('Automotive') },
    { value: 'bar', label: __('Bar & Nightclub') },
    { value: 'business', label: __('Business & Consulting') },
    { value: 'children', label: __('Childcare') },
    { value: 'cleaning', label: __('Cleaning & Maintenance') },
    { value: 'communications', label: __('Communications') },
    { value: 'community', label: __('Community & Non-Profit') },
    { value: 'computer', label: __('Computer') },
    { value: 'construction', label: __('Construction') },
    { value: 'cosmetics', label: __('Cosmetics & Beauty') },
    { value: 'dating', label: __('Dating') },
    { value: 'education', label: __('Education') },
    { value: 'entertainment', label: __('Entertainment & The Arts') },
    { value: 'environment', label: __('Environmental') },
    { value: 'fashion', label: __('Fashion') },
    { value: 'floral', label: __('Floral') },
    { value: 'food', label: __('Food & Drink') },
    { value: 'games', label: __('Games & Recreational') },
    { value: 'home', label: __('Home Furnishing') },
    { value: 'industrial', label: __('Industrial') },
    { value: 'internet', label: __('Internet') },
    { value: 'landscaping', label: __('Landscaping') },
    { value: 'medical', label: __('Medical & Pharmaceutical') },
    { value: 'photography', label: __('Photography') },
    { value: 'physical', label: __('Physical Fitness') },
    { value: 'politics', label: __('Political') },
    { value: 'realestate', label: __('Real Estate & Mortgage') },
    { value: 'religious', label: __('Religious') },
    { value: 'restaurant', label: __('Restaurant') },
    { value: 'retail', label: __('Retail') },
    { value: 'security', label: __('Security') },
    { value: 'spa', label: __('Spa & Esthetics') },
    { value: 'sports', label: __('Sport') },
    { value: 'technology', label: __('Technology') },
    { value: 'travel', label: __('Travel & Hotel') },
    { value: 'wedding', label: __('Wedding Service') },
];

export function getIndustryLabel(value?: string) {
    const industry = industries().find((industry) => industry.value === value);

    return industry ? industry.label.toLowerCase() : '';
}
